export const formatDate = (date, toTimeStamp = false) => {
    if (typeof date === 'string') {
        return date.split('-').reverse().join('.');
    }
    else {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return toTimeStamp ? `${year}-${month}-${day}` : `${day}.${month}.${year}`;
    }
};
//# sourceMappingURL=formatDate.js.map